import React from 'react';

import './styles.scss';

import HeaderApp from 'components/Header/HeaderApp';
import Bottom from 'components/Bottom';
import ContentPendenciaDemanda from './ContentPendeciaDemanda';

const PendenciasLayout = () => {
  return (
    <>
      <HeaderApp />
      <ContentPendenciaDemanda />
      <Bottom />
    </>
  );
};

export default PendenciasLayout;
